import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { UtilsService } from './utils.service';

@Injectable()
export class PaymentDeclarationsService {
  constructor(
    private http: HttpService,
    private utils: UtilsService,
  ) {}

  getPayments(page: number = 1, page_size: number = 10) {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('page_size', page_size.toString());

    return new Promise((resolve, reject) => {
      this.http.get('payment-declaration', params).subscribe(
        (resp: any) => {
          resolve(resp);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }

  postPaymentDeclaration(body: any) {
    body = this.utils.removeEmpty(body);

    return new Promise((resolve, reject) => {
      this.http.post('payment-declaration', body).subscribe(
        (resp: any) => {
          resolve(resp);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }

  updatePaymentDeclaration(id: string, body: any) {
    body = this.utils.removeEmpty(body);

    return new Promise((resolve, reject) => {
      this.http.patch('payment-declaration/' + id, body).subscribe(
        (resp: any) => {
          resolve(resp);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }
}
